"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZebecConnectionProvider = void 0;
/**
 * Zebec connection provider implements provider interface provided anchor. It only encapsulate solana web3 connection.
 *
 * @example
 * const connection = new Connection(process.env.RPC_URL || clusterApiUrl("mainnet-beta"));
 * const connProvider = new ZebecConnectionProvider(connection);
 */
class ZebecConnectionProvider {
    constructor(connection) {
        this.connection = connection;
    }
}
exports.ZebecConnectionProvider = ZebecConnectionProvider;
